module.exports = __webpack_public_path__ + "static/media/RepiSkGrey.20358878.svg";